<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">Adjuntar Archivos</h5>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      (click)="this.close()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <pos-documents-step
      [documentsForm]="this.documentsForm"
    ></pos-documents-step>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="this.close()"
    >
      Cancelar
    </button>
    <button type="button" class="btn btn-outline-primary" (click)="this.confirm()">Confirmar</button>
  </div>
</div>
